export default [
    {
        el: '.j-title-text',
        langKey: 'giftCode'
    },
    {
        el: '.form-label-server',
        langKey: 'server'
    },
    {
        el: '.form-label-role',
        langKey: 'character'
    },
    {
        el: '.form-label-code',
        langKey: 'code'
    },
    {
        el: '.form-submit',
        langKey: 'confirm'
    },
    {
        el: '.step-tip',
        langKey: 'find'
    },
    {
        el: '.step-cont1-tip',
        langKey: 'step1'
    },
    {
        el: '.step-cont2-tip',
        langKey: 'step2'
    },
    {
        el: '.j-popup-valid-title',
        langKey: 'validRole',
    },
    {
        el: '.j-popup-valid-text',
        langKey: 'validToGet',
    },
    {
        el: '.j-popup-valid-confirm',
        langKey: 'goToValid',
    },
    {
        el: '.j-account-change',
        langKey: 'changeAccount'
    }
]